import moment from 'moment';
import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-banking",
    prompt: (guidanceItem) => `To set up/manage your bank account(s) for seamless billing, funding, and reimbursement, click on the three-dot button next to the account type you would like to add/edit. Click Save.`,
    briefDescription: 'Banking',
    beforeLoad: async (component, guidanceItem) => {
        await component.refreshPermissions();
    },
    openAction: {
        text: "Where to edit banking information?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/banking`,
        row: null
    },
    completeAction: {
    },
});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-banking.js